export default __webpack_public_path__ + "static/media/pamela.d321c816.jpg";